import { translate } from './lang'

export const dayFields = (month, year) => {
	const daysInMonth = (32 - new Date(year, month-1, 32).getDate())
	let dayOptions = [{ label: translate('Day'), value: 0 }]
	for (let i=1; i<=daysInMonth; i++) {
		dayOptions.push({ label: i, value: i })
	}
	return dayOptions
}

export const monthFields = () => {
	let months = [translate('Month'), translate('January'), translate('February'), translate('March'), translate('April'), translate('May'), translate('June'), translate('July'), translate('August'), translate('September'), translate('October'), translate('November'), translate('December')]
	return months.map((month, index) => ({ label: month, value: index }))
}

export const yearFields = () => {
	let yearOptions = []
	for (let i=1800; i<=new Date().getFullYear(); i++) {
		yearOptions.push({ label: i, value: i })
	}
	yearOptions.push({ label: translate('Year'), value: 0 })
	return yearOptions
}
